import { defineComponent as _defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        gatewayMessages: {
            type: Array,
            default: [],
        },
        weatherStationDatas: {
            type: Array,
            default: [],
        },
        soilSensorDatas: {
            type: Array,
            default: [],
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const rowsPerPage = 50;
        const gatewayMessagesColumns = [
            { field: 'id', header: 'ID' },
            { field: 'dev_eui', header: 'Dev EUI' },
            { field: 'data', header: 'Data' },
            { field: 'processed', header: 'Processed' },
            { field: 'time', header: 'Time' },
            { field: 'created_at', header: 'Created at' },
        ];
        const weatherStationDatasColumns = [
            { field: 'id' },
            { field: 'weather_station_id' },
            { field: 'wind_direction' },
            { field: 'wind_direction_avg' },
            { field: 'wind_direction_corrected' },
            { field: 'wind_direction_corrected_avg' },
            { field: 'wind_gust_direction_avg' },
            { field: 'wind_speed' },
            { field: 'wind_speed_avg' },
            { field: 'wind_gust_speed_avg' },
            { field: 'wind_sensor_status' },
            { field: 'precipitation_total' },
            { field: 'precipitation_int' },
            { field: 'precipitation_status' },
            { field: 'barometric_pressure' },
            { field: 'pressure_sea_level' },
            { field: 'pressure_station' },
            { field: 'relative_humidity' },
            { field: 'temperature' },
            { field: 'dew_point' },
            { field: 'absolute_humidity' },
            { field: 'air_density' },
            { field: 'wet_bulb_temperature' },
            { field: 'wind_chill' },
            { field: 'heat_index' },
            { field: 'timestamp' },
            { field: 'created_at' },
        ];
        const soilSensorDatasColumns = [
            { field: 'device_serial' },
            { field: 'device_name' },
            { field: 'device_battery' },
            { field: 'dielectric_permittivity' },
            { field: 'volumetric_water_content' },
            { field: 'electrical_conductivity' },
            { field: 'temperature' },
            { field: 'timestamp' },
        ];
        const __returned__ = { props, rowsPerPage, gatewayMessagesColumns, weatherStationDatasColumns, soilSensorDatasColumns, get DataTable() { return DataTable; }, get Column() { return Column; }, get TabView() { return TabView; }, get TabPanel() { return TabPanel; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
